(() => {
  "use strict";

  const boxes = document.querySelectorAll("[data-supplyme-free-ads-buy-box]");

  boxes.forEach((box) => {
    if (box.dataset.supplymeInitialized === "true") return;
    box.dataset.supplymeInitialized = "true";

    const form = box.querySelector("[data-supplyme-free-ads-form]");
    const button = box.querySelector("[data-supplyme-free-ads-submit]");
    const status = box.querySelector("[data-supplyme-free-ads-status]");
    if (!form || !button || !status) return;

    const originalLabel = button.textContent.trim();

    const showStatus = (message, state = "error") => {
      status.textContent = message;
      status.dataset.state = state;
      status.hidden = false;
    };

    const resetTurnstile = () => {
      if (window.turnstile && typeof window.turnstile.reset === "function") {
        try { window.turnstile.reset(); } catch (_) {}
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      status.hidden = true;

      const formData = new FormData(form);
      const email = String(formData.get("email") || "").trim();
      const token = String(formData.get("cf-turnstile-response") || "").trim();
      const website = String(formData.get("website") || "").trim();

      if (!email || !form.elements.email.checkValidity()) {
        form.elements.email.reportValidity();
        return;
      }

      if (!token) {
        showStatus("Please complete the verification and try again.");
        return;
      }

      button.disabled = true;
      button.textContent = "Preparing Your Printable…";

      try {
        const response = await fetch(box.dataset.endpoint, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            product_id: box.dataset.productId,
            variant_id: box.dataset.variantId,
            turnstile_token: token,
            website
          })
        });

        let result = {};
        try { result = await response.json(); } catch (_) {}

        if (!response.ok || result.success !== true) {
          throw new Error(result.error || "We couldn’t prepare your printable. Please try again.");
        }

        window.location.assign(result.redirect_url || box.dataset.redirectUrl);
      } catch (error) {
        showStatus(error instanceof Error ? error.message : "We couldn’t prepare your printable. Please try again.");
        resetTurnstile();
        button.disabled = false;
        button.textContent = originalLabel;
      }
    });
  });
})();
